export const FETCH_EURO_EXCHANGE = 'FETCH_EURO_EXCHANGE';
export const FETCH_EURO_EXCHANGE_FULFILLED = 'FETCH_EURO_EXCHANGE_FULFILLED';
export const FETCH_EURO_EXCHANGE_REJECTED = 'FETCH_EURO_EXCHANGE_REJECTED';
